import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { ContainerWithLogo, Button, GradientSection } from '@app/components';
import colors from '@app/constants/colors';
import RouterConstants from '@app/constants/router';
import { askResetPassword, setError, resetAskForgotPasswordPage } from '@app/actions/userActions';
import ForgotPaswordForm from './ForgotPaswordForm';

class ForgotPasword extends React.Component {
  componentWillUnmount() {
    const { setError, resetAskForgotPasswordPage } = this.props;
    setError(null);
    resetAskForgotPasswordPage();
  }

  render() {
    const { isAskResetComplete, askResetPassword } = this.props;
    return (
      <ContainerWithLogo titleLabel="forgotPage.title">
        {
          isAskResetComplete
            ? (
              <GradientContainer>
                <GradientSection>
                  <HeaderMessage><FormattedMessage id="forgotPage.successMessage" /></HeaderMessage>
                  <Button
                    path={RouterConstants.HOME}
                    labelId="forgotPage.successButton"
                    textColor={colors.ALICE_BLUE}
                    backgroundColor={colors.INTERNATIONAL_ORANGE}
                  />
                </GradientSection>
              </GradientContainer>
            )
            : (
              <ForgotPaswordFormContainer>
                <ForgotPaswordForm onSubmit={askResetPassword} />
              </ForgotPaswordFormContainer>
            )
        }
      </ContainerWithLogo>
    );
  }
}

ForgotPasword.propTypes = {
  isAskResetComplete: PropTypes.bool.isRequired,
  askResetPassword: PropTypes.func.isRequired,
  resetAskForgotPasswordPage: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

const mapStateToProps = ({ user: { isAskResetComplete } }) => ({
  isAskResetComplete,
});

const mapDispatchToProps = {
  askResetPassword,
  setError,
  resetAskForgotPasswordPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasword);

const ForgotPaswordFormContainer = styled.div`
  max-width: 520px;
  width: 100%;
  text-align: center;
  color: white;
  padding: 0 10px;
`;

const GradientContainer = styled.div`
  width: 100%;
  margin-bottom: 50px;
`;

const HeaderMessage = styled.h3`
  margin-bottom: 60px;
  
   @media (max-width: 979px) {
     margin-bottom: 40px;
   }  
`;
